import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faDollarSign } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Api from 'api/Api.js';
import CustomerEndpoints from 'api/CustomerEndpoints';
import ServiceEndpoints from 'api/ServiceEndpoints';

import ReactSelect from '../../../../components/Select/ReactSelect';
import NumberMaskInput from '../../../../components/CustomInput/NumberMaskInput';
import { store } from '../../../../redux/store';
import { SET_ADHOC_SERVICE_LIST } from '../../../../redux/types';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class ChargeAdhocDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            service: { label: 'None Selected', value: '' },
            service_id: 0,
            cost: 0,
            price: 0,
            quantity: 1,
            reference: '',

            loading: false,

            costFormatted: '',
            priceFormatted: '',
            quantityFormatted: '1',

            serviceState: '',
            costState: '',
            priceState: '',
            quantityState: 'success',
            referenceState: '',
        }
    }

    componentDidMount() {
        Api.get(ServiceEndpoints.listAdhoc)
            .then(({ data }) => {
                store.dispatch({ type: SET_ADHOC_SERVICE_LIST, payload: data })
            });
    }

    changeNum(e, name) {
        this.setState({ [name]: e.target.floatValue, [name + "Formatted"]: e.target.formattedValue, [name + "State"]: (e.target.formattedValue ? "success" : "error") });
    }

    submit() {

        if (this.state.serviceState === 'success' &&
            this.state.costState === 'success' &&
            this.state.priceState === 'success' &&
            this.state.quantityState === 'success' &&
            this.state.referenceState === 'success'
        ) {
            this.setState({ loading: true }, () => {
                Api.post(CustomerEndpoints.chargeGeneralAdhoc, { ...this.state, customer_id: this.props.customer_id })
                    .then(({ data }) => {
                        this.setState({ loading: false });
                        this.props.refresh();
                        this.props.close();
                    })
                    .catch((e) => {
                        this.setState({ loading: false });
                        console.error(e);
                    })
            });
        }
        else {
            var newState = {};
            if(this.state.serviceState !== 'success')
                newState = ({ ...newState, serviceState: 'error' });
            if(this.state.costState !== 'success')
                newState = ({ ...newState, costState: 'error' });
            if(this.state.priceState !== 'success')
                newState = ({ ...newState, priceState: 'error' });
            if(this.state.quantityState !== 'success')
                newState = ({ ...newState, quantityState: 'error' });
            if(this.state.referenceState !== 'success')
                newState = ({ ...newState, referenceState: 'error' });

            this.setState(newState);
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Charge Adhoc Fee</DialogTitle>
                <DialogContent style={{ overflow: 'initial' }}>
                    <ReactSelect
                        success={this.state.serviceState === "success"}
                        error={this.state.serviceState === "error"}
                        label="Adhoc Service Provided"
                        options={
                            this.props.adhoc_services && this.props.adhoc_services.length > 0 ?
                                this.props.adhoc_services.map(e => ({ label: e.name, value: e.id }))
                                :
                                [{ label: 'Loading...', value: '' }]
                        }
                        onChange={(obj) => this.setState({ service: obj, service_id: obj.value, serviceState: "success" })}
                        placeholder="No Service Selected"
                        value={this.state.service}
                        isSearchable
                        isLoading={!this.props.adhoc_services || this.props.adhoc_services.length === 0}
                        isDisabled={!this.props.adhoc_services || this.props.adhoc_services.length === 0}
                    />
                    <NumberMaskInput
                        success={this.state.priceState === "success"}
                        error={this.state.priceState === "error"}
                        labelText={
                            <span>
                                Price <small>(required)</small>
                            </span>
                        }
                        id="price"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.changeNum(event, 'price'),
                            value: this.state.priceFormatted
                        }}
                    />
                    <NumberMaskInput
                        success={this.state.costState === "success"}
                        error={this.state.costState === "error"}
                        labelText={
                            <span>
                                Cost <small>(required)</small>
                            </span>
                        }
                        id="cost"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.changeNum(event, 'cost'),
                            value: this.state.costFormatted
                        }}
                    />
                    <NumberMaskInput
                        success={this.state.quantityState === "success"}
                        error={this.state.quantityState === "error"}
                        labelText={
                            <span>
                                Quantity <small>(required)</small>
                            </span>
                        }
                        id="quantity"
                        type="number"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.changeNum(event, 'quantity'),
                            value: this.state.quantityFormatted
                        }}
                    />
                    <CustomInput
                        success={this.state.referenceState === "success"}
                        error={this.state.referenceState === "error"}
                        labelText={
                            <span>
                                Reference <small>(required)</small>
                            </span>
                        }
                        id="reference"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.setState({ reference: event.target.value, referenceState: (event.target.value ? "success" : "error") }),
                            value: this.state.reference
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>

                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                <FontAwesomeIcon icon={faDollarSign} />
                                &nbsp;&nbsp;
                                Charge Fee
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(ChargeAdhocDialog);